import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Suspense} from 'react'
import {pullRequestsLayoutRoute} from './layout-route'
import {usePullRequestBasePath} from '../stores/layout-selectors'

export const FindingsEntrypoint = () => (
  <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  </ErrorBoundary>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()
  const {
    data: {aliveChannels},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')

  return <Findings pullRequestBasePath={basePath} aliveChannel={aliveChannels.pullRequest} variant="page" />
}
